module.exports = __webpack_public_path__ + "img/plane_103.289b20bc.jpg";